var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader"},[_vm._v("loading...")]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"row gy-3"},_vm._l((_vm.albums),function(album){return _c('div',{key:album.id,staticClass:"col-6 col-md-4 col-lg-3"},[_c('album-card',{attrs:{"album":album}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }